import { render } from "./Text.vue?vue&type=template&id=7c0216bd&scoped=true"
const script = {}

import "./Text.vue?vue&type=style&index=0&id=7c0216bd&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0216bd"]])

export default __exports__